export default "__VITE_ASSET__DTLolvpb__"